
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<blockquote>
<p parentName="blockquote">{`We aspire to adhere to the fundamental design regulations, as described in the `}<a parentName="p" {...{
          "href": "https://swiss.github.io/styleguide"
        }}>{`«Confederation Web Guidelines»`}</a>{`.`}</p>
</blockquote>
<h2>{`Principles`}</h2>
<p>{`The goal is to establish a visual coherence between Visualize and other websites within the `}<a parentName="p" {...{
        "href": "https://www.admin.ch"
      }}>{`admin.ch`}</a>{` domain.
Specifically, we aim to adhere to the guidelines and elements which represent compliance with the primary category of brand elements — the so called «Corporate Design Elements» (CD):`}</p>
<ul>
<li parentName="ul">{`designation of the website, comprising of the Confederation logo and the name of the organizational unit`}</li>
<li parentName="ul">{`line separating the header from the rest of the page`}</li>
<li parentName="ul">{`footer with the copyright notice, links to the legal notice and further legal information`}</li>
<li parentName="ul">{`«Noto Sans» typeface`}</li>
<li parentName="ul">{`prescribed color range`}</li>
</ul>
<h2>{`Demarcations`}</h2>
<p>{`Since Visualize serves specific use cases and therefore has unique requirements, we reserve the right to be non-compliant towards the use of so called «Fixed» elements, replacing them with our own components if needed, as well as adapting certain «Flexible» brand elements where necessary.`}</p>
<p>{`While we use the prescribed color range for our basic user interface components, we need to extend the color range for the purpose of creating accessible charts and maps within Visualize. Our extended color range is based on the main colors, described in the official «Corporate Design Manual» of the Bundesamt für Umwelt (BAFU).`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;